import { ResetPassword } from '@belong/journey-authentication';
import { Column, Columns, Section } from '@belong/ui-components';
import { SECTION_TEST_ID } from 'src/helpers/constants/testIds';

const ForgotPasswordPage = () => {
  return (
    <Section
      containsCard
      hasPaddingTop
      hasPaddingBottom
      hasBackground="grey"
      data-testid={SECTION_TEST_ID.PASSWORD_RESET_LINK}
    >
      <Columns alignX="center">
        <Column width={{ lg: '2/3', xl: '1/2' }}>
          <ResetPassword />
        </Column>
      </Columns>
    </Section>
  );
};

export default ForgotPasswordPage;
